import React from 'react';
import { ReactComponent as CountSVG } from './count.svg';

export default function InventoryCount({width = 16, height = 16, color = '#717182'})
{
  return (
    <CountSVG
      width={width}
      height={height}
      style={{stroke: color}}
    />
  );
}
